import * as React from "react";

function SvgWelcomeTour(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={255}
      height={196.126}
      {...props}
    >
      <defs>
        <style>
          {
            ".welcomeTour_svg__cls-1{fill:#ebebeb}.welcomeTour_svg__cls-2{fill:#f0f0f0}.welcomeTour_svg__cls-3{fill:#f5f5f5}.welcomeTour_svg__cls-4{fill:#e0e0e0}.welcomeTour_svg__cls-5{fill:#e6e6e6}.welcomeTour_svg__cls-7{fill:#fff}.welcomeTour_svg__cls-9{fill:#263238}.welcomeTour_svg__cls-10{fill:#6c6}.welcomeTour_svg__cls-11{fill:#b55b52}.welcomeTour_svg__cls-12{opacity:.2}.welcomeTour_svg__cls-14{fill:#ff8b7b}.welcomeTour_svg__cls-15{fill:#ff5652}"
          }
        </style>
      </defs>
      <g
        id="welcomeTour_svg__Bye-rafiki_1_"
        data-name="Bye-rafiki (1)"
        transform="translate(0 -43)"
      >
        <g
          id="welcomeTour_svg__freepik--background-complete--inject-44"
          transform="translate(0 49.1)"
        >
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1644"
            data-name="Ret\xE2ngulo 1644"
            className="welcomeTour_svg__cls-1"
            transform="translate(0 167.068)"
            d="M0 0h255v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1645"
            data-name="Ret\xE2ngulo 1645"
            className="welcomeTour_svg__cls-1"
            transform="translate(212.695 175.248)"
            d="M0 0h16.837v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1646"
            data-name="Ret\xE2ngulo 1646"
            className="welcomeTour_svg__cls-1"
            transform="translate(132.78 173.656)"
            d="M0 0h6.553v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1647"
            data-name="Ret\xE2ngulo 1647"
            className="welcomeTour_svg__cls-1"
            transform="translate(164.521 174.195)"
            d="M0 0h13.797v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1648"
            data-name="Ret\xE2ngulo 1648"
            className="welcomeTour_svg__cls-1"
            transform="translate(183.507 170.53)"
            d="M0 0h28.524v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1649"
            data-name="Ret\xE2ngulo 1649"
            className="welcomeTour_svg__cls-1"
            transform="translate(26.668 176.412)"
            d="M0 0h13.487v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1650"
            data-name="Ret\xE2ngulo 1650"
            className="welcomeTour_svg__cls-1"
            transform="translate(44.831 176.412)"
            d="M0 0h11.692v.127H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1651"
            data-name="Ret\xE2ngulo 1651"
            className="welcomeTour_svg__cls-1"
            transform="translate(66.84 173.595)"
            d="M0 0h30.913v.127H0z"
          />
          <path
            id="welcomeTour_svg__Caminho_789"
            data-name="Caminho 789"
            className="welcomeTour_svg__cls-1"
            d="M139.266 198.762H41.108a2.9 2.9 0 01-2.9-2.9V57.877a2.9 2.9 0 012.9-2.877h98.158a2.9 2.9 0 012.9 2.9v137.96a2.9 2.9 0 01-2.9 2.902zM41.108 55.1a2.776 2.776 0 00-2.771 2.776V195.86a2.776 2.776 0 002.771 2.776h98.158a2.781 2.781 0 002.776-2.776V57.877a2.781 2.781 0 00-2.776-2.776z"
            transform="translate(-18.786 -55)"
          />
          <path
            id="welcomeTour_svg__Caminho_790"
            data-name="Caminho 790"
            className="welcomeTour_svg__cls-1"
            d="M355.566 198.762H257.4a2.908 2.908 0 01-2.9-2.9V57.877A2.908 2.908 0 01257.4 55h98.163a2.9 2.9 0 012.893 2.877V195.86a2.9 2.9 0 01-2.89 2.902zM257.4 55.1a2.781 2.781 0 00-2.776 2.776V195.86a2.781 2.781 0 002.776 2.776h98.163a2.781 2.781 0 002.776-2.776V57.877a2.781 2.781 0 00-2.776-2.776z"
            transform="translate(-124.301 -55)"
          />
          <path
            id="welcomeTour_svg__Caminho_791"
            data-name="Caminho 791"
            className="welcomeTour_svg__cls-2"
            d="M257.565 271q.473 0 .961.031a13.726 13.726 0 0112.274 17.253 68.5 68.5 0 00-2.15 17.848v17.528a2.3 2.3 0 01-2.3 2.3h-55.64V271z"
            transform="translate(-103.139 -160.562)"
          />
          <path
            id="welcomeTour_svg__Caminho_792"
            data-name="Caminho 792"
            className="welcomeTour_svg__cls-3"
            d="M183.759 284.59a13.726 13.726 0 1126.943 3.558A68.719 68.719 0 00208.557 306v17.528a2.3 2.3 0 01-2.3 2.3h-17.582a2.3 2.3 0 01-2.3-2.3V304.97a62.451 62.451 0 00-2.125-16.725 13.838 13.838 0 01-.491-3.655z"
            transform="translate(-90.005 -160.427)"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1652"
            data-name="Ret\xE2ngulo 1652"
            className="welcomeTour_svg__cls-2"
            transform="rotate(180 88.222 82.7)"
            d="M0 0h49.941v33.363H0z"
          />
          <path
            id="welcomeTour_svg__Caminho_793"
            data-name="Caminho 793"
            className="welcomeTour_svg__cls-4"
            d="M338.568 230.44h46.1a8.939 8.939 0 019.054 10.37l-5.234 39.39H321.65l5.231-39.392a12.131 12.131 0 0111.687-10.368z"
            transform="translate(-157.315 -140.807)"
          />
          <path
            id="welcomeTour_svg__Caminho_794"
            data-name="Caminho 794"
            className="welcomeTour_svg__cls-3"
            d="M304.25 230.44h47.1a8.536 8.536 0 018.642 9.872l-5.3 39.891H287.83l5.3-39.891a11.547 11.547 0 0111.12-9.872z"
            transform="translate(-140.687 -140.807)"
          />
          <path
            id="welcomeTour_svg__Caminho_795"
            data-name="Caminho 795"
            className="welcomeTour_svg__cls-4"
            d="M.9 0h46.031a3.009 3.009 0 013.009 3.009v7.564a3.009 3.009 0 01-3.009 3.009H.9a.9.9 0 01-.9-.9V.9A.9.9 0 01.9 0z"
            transform="rotate(180 87.025 71.222)"
          />
          <path
            id="welcomeTour_svg__Caminho_796"
            data-name="Caminho 796"
            className="welcomeTour_svg__cls-2"
            d="M391.675 271q.478 0 .961.031a13.725 13.725 0 0112.256 17.253 68.721 68.721 0 00-2.145 17.848v17.528a2.3 2.3 0 01-2.3 2.3H344.81V271z"
            transform="translate(-168.701 -160.562)"
          />
          <path
            id="welcomeTour_svg__Caminho_797"
            data-name="Caminho 797"
            className="welcomeTour_svg__cls-3"
            d="M317.849 284.59a13.726 13.726 0 1126.943 3.559 68.507 68.507 0 00-2.15 17.851v17.528a2.3 2.3 0 01-2.3 2.3H322.77a2.3 2.3 0 01-2.3-2.3V304.97a62.655 62.655 0 00-2.12-16.725 13.634 13.634 0 01-.501-3.655z"
            transform="translate(-155.682 -160.427)"
          />
          <path
            id="welcomeTour_svg__Caminho_798"
            data-name="Caminho 798"
            className="welcomeTour_svg__cls-4"
            d="M211.013 380.787h113.062a1.667 1.667 0 001.667-1.667H209.33a1.667 1.667 0 001.683 1.667z"
            transform="translate(-102.093 -213.719)"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1653"
            data-name="Ret\xE2ngulo 1653"
            className="welcomeTour_svg__cls-5"
            transform="rotate(180 102.154 39.156)"
            d="M0 0h159.343v65.547H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1654"
            data-name="Ret\xE2ngulo 1654"
            className="welcomeTour_svg__cls-3"
            transform="rotate(180 101.674 39.156)"
            d="M0 0h160.416v65.547H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1655"
            data-name="Ret\xE2ngulo 1655"
            className="welcomeTour_svg__cls-5"
            transform="rotate(180 102.154 40.542)"
            d="M0 0h159.343v2.481H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1656"
            data-name="Ret\xE2ngulo 1656"
            className="welcomeTour_svg__cls-3"
            transform="rotate(180 98.558 40.542)"
            d="M0 0h156.014v2.481H0z"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1657"
            data-name="Ret\xE2ngulo 1657"
            transform="rotate(90 92.007 108.534)"
            d="M0 0h58.034v154.783H0z"
            fill="#fafafa"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1658"
            data-name="Ret\xE2ngulo 1658"
            className="welcomeTour_svg__cls-5"
            transform="rotate(90 14.628 31.149)"
            d="M0 0h58.034v.402H0z"
          />
          <path
            id="welcomeTour_svg__Caminho_799"
            data-name="Caminho 799"
            className="welcomeTour_svg__cls-7"
            d="M350.791 145.534L340.369 87.5H326.71l10.421 58.034z"
            transform="translate(-160.032 -70.979)"
          />
          <path
            id="welcomeTour_svg__Caminho_800"
            data-name="Caminho 800"
            className="welcomeTour_svg__cls-7"
            d="M248.813 145.534L238.391 87.5h-6.171l10.421 58.034z"
            transform="translate(-113.761 -70.979)"
          />
          <rect
            id="welcomeTour_svg__Ret\xE2ngulo_1659"
            data-name="Ret\xE2ngulo 1659"
            className="welcomeTour_svg__cls-1"
            width={61.612}
            height={0.646}
            rx={0.323}
            transform="rotate(90 94.211 104.576)"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1660"
            data-name="Ret\xE2ngulo 1660"
            transform="rotate(180 102.692 26.95)"
            d="M0 0h163.929v43.53H0z"
            opacity={0.5}
            fill="#e6e6e6"
          />
          <path
            id="welcomeTour_svg__Ret\xE2ngulo_1661"
            data-name="Ret\xE2ngulo 1661"
            className="welcomeTour_svg__cls-4"
            transform="rotate(180 102.692 5.762)"
            d="M0 0h163.929v1.154H0z"
          />
          <rect
            id="welcomeTour_svg__Ret\xE2ngulo_1662"
            data-name="Ret\xE2ngulo 1662"
            className="welcomeTour_svg__cls-1"
            width={164.584}
            height={1.012}
            rx={0.506}
            transform="rotate(180 102.857 5.437)"
          />
          <path
            id="welcomeTour_svg__Caminho_801"
            data-name="Caminho 801"
            className="welcomeTour_svg__cls-7"
            d="M80.414 161.033h164.1a.244.244 0 00.239-.244.239.239 0 00-.239-.239h-164.1a.244.244 0 00-.244.239.249.249 0 00.244.244z"
            transform="translate(-39.041 -106.7)"
          />
          <path
            id="welcomeTour_svg__Caminho_802"
            data-name="Caminho 802"
            className="welcomeTour_svg__cls-5"
            d="M74.933 230.406c-5.561-7.864-18.809-10.782-23.384-15.759-6-6.512-5.968-16.267-.859-19.8 4.443-3.05 19.155 17.64 20.812 19.953a44.718 44.718 0 018.423 19.577c-.122-4.865-.239-9.328-.336-12.77-.31-11.235-.7-14.849-.879-15.957a67.777 67.777 0 00-1.759-1.525c-3.558-2.872-11.433-5.084-15.378-9.257-5.765-6.1-4.631-15.7-1.525-17.452 4.433-2.5 13.512 3.482 16.374 10.675 2.181 5.48 2.969 11.352 3.386 18.524.066 1.1.473 5.2.7 10.894a22.891 22.891 0 018.042-14.076c5.465-4.712 10.167-10.447 14.686-9.71s2.079 8.337-1.484 13.665c-3.172 4.748-18.809 9.481-21.127 13.3.275 7.727.508 17.523.686 26.638 1.235-4.707.386-5.084 5.444-12.312 3-4.291 15.327-9.572 16.776-6.609s-.768 8.51-5.419 12.409c-3.752 3.147-12.078 3.142-14.005 5.084-.447.458-1.932 2.2-2.781 3.2.2 11.133.29 20.959.188 24.309l-.808.036c.041-.864-.056-6.527-.214-14.02-2.033-3.991-15.637-6.319-19.826-10.462-4.4-4.341-7.559-9.4-5.673-12.8 1.576-2.826 13.975 1.017 19.012 5.7a19.862 19.862 0 016.352 10.939c-.117-5.109-.244-10.589-.371-15.759-1.037-1.302-3.365-4.276-5.053-6.635z"
            transform="translate(-23.081 -114.27)"
          />
          <path
            id="welcomeTour_svg__Caminho_803"
            data-name="Caminho 803"
            className="welcomeTour_svg__cls-2"
            d="M108.023 372.862H81.9a2.928 2.928 0 01-2.943-2.033L77.1 363h35.717l-1.855 7.818a2.923 2.923 0 01-2.938 2.044z"
            transform="translate(-37.758 -205.794)"
          />
          <path
            id="welcomeTour_svg__Caminho_804"
            data-name="Caminho 804"
            className="welcomeTour_svg__cls-2"
            d="M110.412 360.469H73.2a1.672 1.672 0 01-1.739-1.327l-.763-5.755a1.607 1.607 0 011.744-1.667h38.731a1.62 1.62 0 011.739 1.667l-.763 5.78a1.672 1.672 0 01-1.737 1.302z"
            transform="translate(-34.754 -200.248)"
          />
        </g>
        <g
          id="welcomeTour_svg__freepik--Shadow--inject-44"
          transform="translate(28.524 227.616)"
        >
          <ellipse
            id="welcomeTour_svg__freepik--path--inject-44"
            className="welcomeTour_svg__cls-3"
            cx={98.976}
            cy={5.755}
            rx={98.976}
            ry={5.755}
          />
        </g>
        <g
          id="welcomeTour_svg__freepik--character-1--inject-44"
          transform="translate(68.23 54.848)"
        >
          <path
            id="welcomeTour_svg__Caminho_805"
            data-name="Caminho 805"
            className="welcomeTour_svg__cls-9"
            d="M196.9 114.116c.158-.173 1.774-1.825 1.174-2.826a4.88 4.88 0 01-4.473 2.913 8.3 8.3 0 00.508-2.832 7.808 7.808 0 01-2.145 2.847 23.049 23.049 0 01-5.45-1.078c-7.534.691-7.717-5.241-7.778-6.563a11.183 11.183 0 00-.259 2.694c-1.627-2.582-1.367-6.5.778-7.234.391-8.337 6.415-9.079 7.93-9.41 2.735-.6 7.508-2.893 9.872 2.033 3.32 1.784 4.575 5.978 3.157 12.373 2.852 4.582-3.014 6.967-3.314 7.083z"
            transform="translate(-155.193 -78.728)"
          />
          <path
            id="welcomeTour_svg__Caminho_806"
            data-name="Caminho 806"
            className="welcomeTour_svg__cls-9"
            d="M193.032 410.458c3.935 0 4.453-.061 6.664-.137 1.891-.066 2.344.168 3.869.137 1.271-.031 1.22-1.245.829-2.643-.193-.7-.508-2.191-.768-3.325l-5.978.625a5.932 5.932 0 01-4.641 3.009c-2.12.285-1.541 2.334.025 2.334z"
            transform="translate(-162.173 -231.94)"
          />
          <path
            id="welcomeTour_svg__Caminho_807"
            data-name="Caminho 807"
            className="welcomeTour_svg__cls-9"
            d="M185.711 376.327c2.328-3.086 2.918-4.27 4.174-6.049 1.073-1.525 1.281-1.144 2.425-2.648a1.8 1.8 0 00-1.017-2.72 16.78 16.78 0 01-2.943-.879l-3.924 2.893c.717 1.855.8 6.1-.813 8.566-1.166 1.767 1.157 2.072 2.098.837z"
            transform="translate(-158.075 -212.048)"
          />
          <path
            id="welcomeTour_svg__Caminho_808"
            data-name="Caminho 808"
            className="welcomeTour_svg__cls-10"
            d="M146.509 202.67s-11.306 32.321-12.77 44.15c-1.428 11.57 26.592 41.654 26.592 41.654.676.508 3.482-2.979 3.64-3.894 0 0-11.123-24.5-18.87-37.389 16.776-24.853 19.689-41.624 19.689-41.624z"
            transform="translate(-133.686 -132.716)"
          />
          <path
            id="welcomeTour_svg__Caminho_809"
            data-name="Caminho 809"
            className="welcomeTour_svg__cls-10"
            d="M169.69 204.38s6.319 32.535 8.728 48.212c2.542 16.45 9.079 43.383 8.444 54.14.92.539 4.306-.371 6.1-.94 0 0 4.651-35.285-3.37-51.572 5.19-38.065-4.428-47.384-4.428-47.384z"
            transform="translate(-151.387 -133.557)"
          />
          <path
            id="welcomeTour_svg__Caminho_810"
            data-name="Caminho 810"
            className="welcomeTour_svg__cls-9"
            d="M202.37 395.5a41.3 41.3 0 01-.208 3.935c-.051.463.127.895.386.971 2.186.62 5.353-.285 6.359-.6.193-.061.336-.33.366-.676l.325-3.68c.046-.508-.173-.961-.463-.951l-6.314.219c-.237.001-.441.341-.451.782z"
            transform="translate(-167.348 -227.024)"
          />
          <path
            id="welcomeTour_svg__Caminho_811"
            data-name="Caminho 811"
            className="welcomeTour_svg__cls-9"
            d="M179.087 360.416c.61.829 1.688 2.3 2.466 3.416.259.366.641.559.874.452a18.5 18.5 0 004.519-3.772c.132-.147.1-.447-.076-.742l-1.922-3.177c-.259-.432-.727-.686-.966-.508l-5 3.457c-.2.131-.159.538.105.874z"
            transform="translate(-155.894 -208.114)"
          />
          <path
            id="welcomeTour_svg__Caminho_812"
            data-name="Caminho 812"
            className="welcomeTour_svg__cls-11"
            d="M167.568 116.946c-.178-.259-.28-.422-.407-.625l-.351-.58a27.795 27.795 0 01-.635-1.154q-.61-1.159-1.139-2.344a37.2 37.2 0 01-1.774-4.89 34.961 34.961 0 01-1.078-5.119c-.127-.869-.2-1.744-.249-2.623 0-.442-.041-.879-.036-1.322v-.661a5.188 5.188 0 01.046-.854 15.911 15.911 0 01.554-2.826c.239-.864.508-1.678.8-2.476.585-1.6 1.245-3.116 1.937-4.611a83.977 83.977 0 014.687-8.642 1.6 1.6 0 012.867 1.378v.031c-1.062 2.979-2.11 6-3.076 8.972-.478 1.495-.93 2.984-1.3 4.448a48.143 48.143 0 00-.508 2.155 12.518 12.518 0 00-.219 1.911v.346l.046.544c.025.356.076.717.112 1.078.107.717.208 1.434.356 2.145a35.358 35.358 0 001.123 4.235 41.173 41.173 0 001.611 4.107c.3.676.62 1.337.956 1.983l.508.951.259.463.234.391.086.142a3.218 3.218 0 01-5.439 3.426z"
            transform="translate(-147.557 -71.798)"
          />
          <path
            id="welcomeTour_svg__Caminho_813"
            data-name="Caminho 813"
            className="welcomeTour_svg__cls-11"
            d="M182.958 71.321a3.05 3.05 0 01-.958 1.947l-2.516 2.171a1.113 1.113 0 01-1.271.142l-1.378-.712a11.387 11.387 0 011.276-5.668l.62-2.394a.569.569 0 01.8-.447l3.289 1.713a.946.946 0 01.432.951z"
            transform="translate(-154.895 -66.307)"
          />
          <path
            id="welcomeTour_svg__Caminho_814"
            data-name="Caminho 814"
            className="welcomeTour_svg__cls-9"
            d="M170.057 148.479c8.327-2.821 4.357-8.9 2.1-14.63-2.186-1.657-8.642 5.16-8.642 5.16s-1.637 8.84 6.542 9.47z"
            transform="translate(-148.287 -99.253)"
          />
          <path
            id="welcomeTour_svg__Caminho_815"
            data-name="Caminho 815"
            className="welcomeTour_svg__cls-9"
            d="M161.63 147.55a95.339 95.339 0 00-1.383 9.618c-.508 4.194-.859 8.337-1.337 15.251l20.975 3.325c.508-5.978 2.267-12.6 8.134-25.3a4.956 4.956 0 00-3.177-7.02 53.4 53.4 0 00-2.588-.61 67.819 67.819 0 00-9.521-1.525 74.338 74.338 0 00-3.192-.127 8 8 0 00-7.911 6.388z"
            transform="translate(-146.087 -102.94)"
          />
          <path
            id="welcomeTour_svg__Caminho_816"
            data-name="Caminho 816"
            className="welcomeTour_svg__cls-11"
            d="M195.507 123.13c-1.317 2.933-3.223 8.383-1.556 10.747 0 0-2.832-.9-9.6 1.937-1.383-2.842.076-3.447.076-3.447 3.6-.264 4.107-2.786 4.067-5.231z"
            transform="translate(-158.304 -94.133)"
          />
          <path
            id="welcomeTour_svg__Caminho_817"
            data-name="Caminho 817"
            className="welcomeTour_svg__cls-7"
            d="M187.71 144.581c1.988.61 2.135 3.777 2.135 3.777s5.424-2.679 7.351-4.865a20.646 20.646 0 01-1.6-1.413s-6.513 1.484-7.886 2.501z"
            transform="translate(-160.247 -103.419)"
          />
          <path
            id="welcomeTour_svg__Caminho_818"
            data-name="Caminho 818"
            className="welcomeTour_svg__cls-7"
            d="M181.242 143.211a3.9 3.9 0 00-2.852 2.542c.244-4.545 2.45-4.972 2.45-4.972a2.608 2.608 0 011.876 0 2.2 2.2 0 00-1.474 2.43z"
            transform="translate(-155.665 -102.698)"
          />
          <path
            id="welcomeTour_svg__Caminho_819"
            data-name="Caminho 819"
            className="welcomeTour_svg__cls-12"
            d="M197.135 126.34l-4.148 2.369a9.612 9.612 0 01-.1 1.718c1.347 0 3.477-1.113 3.935-2.44a4.62 4.62 0 00.31-1.647z"
            transform="translate(-162.794 -95.822)"
          />
          <path
            id="welcomeTour_svg__Caminho_820"
            data-name="Caminho 820"
            className="welcomeTour_svg__cls-11"
            d="M198.794 103.264c-1.713 4.8-2.338 6.863-5.536 8.789-4.814 2.9-10.35.086-10.106-5.048.214-4.616 2.979-11.692 8.337-12.521a6.526 6.526 0 017.305 8.78z"
            transform="translate(-158.002 -80.118)"
          />
          <path
            id="welcomeTour_svg__Caminho_821"
            data-name="Caminho 821"
            className="welcomeTour_svg__cls-9"
            d="M209.632 98.367c-2.593 1.556-2.506 9.923 1.8 9.313 4-4.839.98-10.792-1.8-9.313z"
            transform="translate(-170.171 -81.956)"
          />
          <path
            id="welcomeTour_svg__Caminho_822"
            data-name="Caminho 822"
            className="welcomeTour_svg__cls-9"
            d="M199.639 94.228c-2.994 4.7-14.31.63-16.979-1.611 1.922.574 5.16.071 7.5-.508s8.818-3.631 9.479 2.119z"
            transform="translate(-157.764 -78.34)"
          />
          <path
            id="welcomeTour_svg__Caminho_823"
            data-name="Caminho 823"
            className="welcomeTour_svg__cls-9"
            d="M186.44 91.454a18.067 18.067 0 009.791-.259l3.421-.28c-2.496-1.647-9.267.473-13.212.539z"
            transform="translate(-159.622 -78.098)"
          />
          <path
            id="welcomeTour_svg__Caminho_824"
            data-name="Caminho 824"
            className="welcomeTour_svg__cls-9"
            d="M200.261 110.665c-.127.407-.442.686-.707.625s-.381-.442-.254-.854.447-.691.712-.625.376.442.249.854z"
            transform="translate(-165.92 -87.691)"
          />
          <path
            id="welcomeTour_svg__Caminho_825"
            data-name="Caminho 825"
            className="welcomeTour_svg__cls-9"
            d="M190.19 107.966c-.127.412-.447.691-.712.63s-.376-.447-.249-.854.442-.691.707-.63.376.447.254.854z"
            transform="translate(-160.968 -86.365)"
          />
          <path
            id="welcomeTour_svg__Caminho_826"
            data-name="Caminho 826"
            className="welcomeTour_svg__cls-9"
            d="M190.035 106.728l-.885-.508s.259.905.885.508z"
            transform="translate(-160.955 -85.93)"
          />
          <path
            id="welcomeTour_svg__Caminho_827"
            data-name="Caminho 827"
            d="M191.542 111.3a12.82 12.82 0 01-2.252 2.272c.361.625 1.378.625 1.378.625z"
            transform="translate(-161.024 -88.428)"
            fill="#a02724"
          />
          <path
            id="welcomeTour_svg__Caminho_828"
            data-name="Caminho 828"
            className="welcomeTour_svg__cls-9"
            d="M194.871 120.006a3.944 3.944 0 01-.7-.1.117.117 0 01-.081-.152.132.132 0 01.153-.092 3.559 3.559 0 003.009-.651.127.127 0 01.178 0 .122.122 0 010 .173 3.767 3.767 0 01-2.559.822z"
            transform="translate(-163.382 -92.203)"
          />
          <path
            id="welcomeTour_svg__Caminho_829"
            data-name="Caminho 829"
            className="welcomeTour_svg__cls-11"
            d="M210.64 117.886a4.067 4.067 0 01-2.745 1.495c-1.383.117-1.728-1.281-1.062-2.542.6-1.129 2.033-2.542 3.294-2.084s1.373 2.045.513 3.131z"
            transform="translate(-169.487 -90.083)"
          />
          <path
            id="welcomeTour_svg__Caminho_830"
            data-name="Caminho 830"
            className="welcomeTour_svg__cls-9"
            d="M203.237 104.179a.219.219 0 01-.158-.1 1.815 1.815 0 00-1.525-.864.239.239 0 01-.244-.239.269.269 0 01.259-.254 2.272 2.272 0 011.917 1.073.259.259 0 01-.086.346.264.264 0 01-.163.038z"
            transform="translate(-166.933 -84.21)"
          />
          <path
            id="welcomeTour_svg__Caminho_831"
            data-name="Caminho 831"
            className="welcomeTour_svg__cls-9"
            d="M188.913 102.344a.218.218 0 01-.163-.071.249.249 0 010-.351 2.628 2.628 0 012.2-.752.229.229 0 01.173.29.269.269 0 01-.305.193 2.094 2.094 0 00-1.734.615.279.279 0 01-.171.076z"
            transform="translate(-160.723 -83.437)"
          />
          <path
            id="welcomeTour_svg__Caminho_832"
            data-name="Caminho 832"
            className="welcomeTour_svg__cls-9"
            d="M200.145 109.428l-.885-.508s.24.88.885.508z"
            transform="translate(-165.925 -87.258)"
          />
          <path
            id="welcomeTour_svg__Caminho_833"
            data-name="Caminho 833"
            className="welcomeTour_svg__cls-11"
            d="M188.682 205.34l1.047-1.185a1.85 1.85 0 011.576-.615l2.771.295a3.416 3.416 0 012.633 1.728l.341.6a11.7 11.7 0 01-4.88 3.162l-.9.412a1.525 1.525 0 01-2.033-.722l-.839-1.769a1.779 1.779 0 01.284-1.906z"
            transform="translate(-160.507 -133.515)"
          />
          <path
            id="welcomeTour_svg__Caminho_834"
            data-name="Caminho 834"
            className="welcomeTour_svg__cls-11"
            d="M208.4 156.555c.173.407.305.737.447 1.1s.259.712.386 1.068c.249.712.508 1.423.707 2.14a50.588 50.588 0 011.113 4.372 41.283 41.283 0 01.691 4.524 32.755 32.755 0 01.112 4.7v.163a2.159 2.159 0 01-.071.447 6.537 6.537 0 01-1.373 2.542 10.385 10.385 0 01-1.688 1.566 17.518 17.518 0 01-3.431 1.947 27.96 27.96 0 01-3.457 1.245 28.632 28.632 0 01-3.558.8 1.606 1.606 0 01-1.017-3l.071-.041c.94-.508 1.947-1.017 2.887-1.566s1.871-1.1 2.73-1.688a15.761 15.761 0 002.277-1.825 4.719 4.719 0 00.712-.874c.153-.259.193-.442.163-.463l-.076.61a35.5 35.5 0 00-.4-3.818c-.224-1.291-.508-2.582-.813-3.879s-.7-2.588-1.1-3.874c-.2-.641-.407-1.281-.63-1.916l-.336-.94-.32-.89-.046-.122a3.223 3.223 0 016.014-2.323z"
            transform="translate(-164.522 -109.473)"
          />
          <path
            id="welcomeTour_svg__Caminho_835"
            data-name="Caminho 835"
            className="welcomeTour_svg__cls-9"
            d="M207.946 145.44c3.447.6 4.824 2.542 7.519 9.532-1.332 2.567-7.381 4.931-7.381 4.931s-3.084-9.893-.138-14.463z"
            transform="translate(-169.569 -105.057)"
          />
        </g>
        <g
          id="welcomeTour_svg__freepik--character-2--inject-44"
          transform="translate(119.331 43)"
        >
          <path
            id="welcomeTour_svg__Caminho_836"
            data-name="Caminho 836"
            className="welcomeTour_svg__cls-14"
            d="M356.324 386.2l4.855-1.332-2.654-11.387-4.855 1.332z"
            transform="translate(-292.656 -204.846)"
          />
          <path
            id="welcomeTour_svg__Caminho_837"
            data-name="Caminho 837"
            className="welcomeTour_svg__cls-9"
            d="M361.671 391.848l-5.328 1.367a.417.417 0 00-.315.437l.366 4.535a.773.773 0 00.966.681c1.911-.508 4.656-1.352 7.071-1.972 2.827-.727 2.572-.544 5.882-1.393 2-.508 1.937-2.659 1.042-2.623-4.067.153-4.474.208-8.393-.956a2.435 2.435 0 00-1.291-.076z"
            transform="translate(-293.815 -213.851)"
          />
          <path
            id="welcomeTour_svg__Caminho_838"
            data-name="Caminho 838"
            className="welcomeTour_svg__cls-12"
            d="M358.525 373.48l1.367 5.871-4.855 1.332-1.367-5.871z"
            transform="translate(-292.656 -204.846)"
          />
          <path
            id="welcomeTour_svg__Caminho_839"
            data-name="Caminho 839"
            className="welcomeTour_svg__cls-10"
            d="M368.9 390.662a.107.107 0 01-.1-.076.117.117 0 01.036-.132c.2-.173 1.957-1.688 2.618-1.525a.356.356 0 01.254.264.712.712 0 01-.1.625c-.442.615-1.881.783-2.7.824zm2.44-1.489a5.228 5.228 0 00-2.074 1.225 3.276 3.276 0 002.155-.7.468.468 0 00.066-.412.142.142 0 00-.1-.107z"
            transform="translate(-300.092 -212.435)"
          />
          <path
            id="welcomeTour_svg__Caminho_840"
            data-name="Caminho 840"
            className="welcomeTour_svg__cls-10"
            d="M368.917 389.867a.132.132 0 01-.066-.1 3.646 3.646 0 01.366-2.1.915.915 0 01.6-.361c.325-.051.452.086.508.213.2.508-.742 1.906-1.281 2.323a.091.091 0 01-.127.025zm1.017-2.333h-.122a.682.682 0 00-.442.275 2.979 2.979 0 00-.33 1.688c.508-.508 1.149-1.566 1.017-1.886.014-.017-.001-.068-.123-.078zm-.051.777z"
            transform="translate(-300.11 -211.64)"
          />
          <path
            id="welcomeTour_svg__Caminho_841"
            data-name="Caminho 841"
            className="welcomeTour_svg__cls-9"
            d="M307.9 237.678c-10.97-24.071-18.835-33.907-19.012-46.88l17.477-3.2s13.593 33 15.027 48.1c1.489 15.7 7.386 48.619 7.386 48.619l-7.971 1.525s-12.513-30.387-12.907-48.164z"
            transform="translate(-260.807 -113.459)"
          />
          <path
            id="welcomeTour_svg__Caminho_842"
            data-name="Caminho 842"
            className="welcomeTour_svg__cls-12"
            d="M292.14 213.23c2.008 6.461 5.734 13.293 10.569 22.876-.854-11.239-4.479-24.345-10.569-22.876z"
            transform="translate(-262.405 -126.309)"
          />
          <path
            id="welcomeTour_svg__Caminho_843"
            data-name="Caminho 843"
            className="welcomeTour_svg__cls-9"
            d="M359.492 373.26l.193 3.533-8.622 2.323-1.144-3.1z"
            transform="translate(-290.812 -204.738)"
          />
          <path
            id="welcomeTour_svg__Caminho_844"
            data-name="Caminho 844"
            className="welcomeTour_svg__cls-14"
            d="M275.657 384.871l-.4 11.692 5.592-.081.4-11.692z"
            transform="translate(-254.106 -210.407)"
          />
          <path
            id="welcomeTour_svg__Caminho_845"
            data-name="Caminho 845"
            className="welcomeTour_svg__cls-9"
            d="M279.847 404.781l-5.5.086a.392.392 0 00-.386.351l-.478 4.5a.818.818 0 00.823.884c1.983-.066 2.6-.229 5.084-.264 2.913-.046 1.571.071 4.987 0 2.064-.036 2.394-2.125 1.525-2.313-2.8-.585-3.558-1.7-4.794-2.887a1.8 1.8 0 00-1.261-.357z"
            transform="translate(-253.233 -220.231)"
          />
          <path
            id="welcomeTour_svg__Caminho_846"
            data-name="Caminho 846"
            className="welcomeTour_svg__cls-12"
            d="M275.838 384.876l-.208 6.029 5.6-.081.2-6.024z"
            transform="translate(-254.288 -210.412)"
          />
          <path
            id="welcomeTour_svg__Caminho_847"
            data-name="Caminho 847"
            className="welcomeTour_svg__cls-10"
            d="M283.875 403.628a.112.112 0 01-.107-.061.117.117 0 010-.137c.173-.193 1.693-1.876 2.389-1.774a.376.376 0 01.3.224.666.666 0 010 .62c-.341.656-1.764.991-2.577 1.129zm2.216-1.739c-.4 0-1.276.8-1.886 1.439 1.1-.229 1.861-.569 2.033-.935a.437.437 0 000-.412.142.142 0 00-.117-.091z"
            transform="translate(-258.278 -218.696)"
          />
          <path
            id="welcomeTour_svg__Caminho_848"
            data-name="Caminho 848"
            className="welcomeTour_svg__cls-10"
            d="M283.764 402.99a.122.122 0 01-.086-.086 3.51 3.51 0 01.036-2.089.859.859 0 01.544-.432c.32-.086.468.036.534.152.29.508-.442 1.947-.915 2.42a.1.1 0 01-.113.035zm.646-2.394a.43.43 0 00-.122 0 .61.61 0 00-.4.315 2.8 2.8 0 00-.066 1.688c.447-.569.9-1.662.727-1.962.01 0-.015-.046-.122-.041zm-.152-.1z"
            transform="translate(-258.167 -218.058)"
          />
          <path
            id="welcomeTour_svg__Caminho_849"
            data-name="Caminho 849"
            className="welcomeTour_svg__cls-9"
            d="M271.519 243.58c-1.586-18.026-5.994-35.691-4.524-48.98l18.3-3.05s2.633 37.257.625 52.615c-2.084 15.967-7.508 48.044-7.508 48.044l-8.134.112s-.915-31.101 1.241-48.741z"
            transform="translate(-249.897 -115.401)"
          />
          <path
            id="welcomeTour_svg__Caminho_850"
            data-name="Caminho 850"
            className="welcomeTour_svg__cls-9"
            d="M282.2 385.97l-.529 3.477-9.115.163-.513-3.289z"
            transform="translate(-252.523 -210.987)"
          />
          <path
            id="welcomeTour_svg__Caminho_851"
            data-name="Caminho 851"
            className="welcomeTour_svg__cls-14"
            d="M294.625 85.193c1.525.468 3.187.961 4.789 1.418s3.228.89 4.829 1.3 3.208.752 4.768 1.017a39.24 39.24 0 002.293.32 14.7 14.7 0 002.033.091l-1.6.58a.818.818 0 00-.28.386c0 .071.041 0 .081-.147a5.171 5.171 0 000-1.637 24.873 24.873 0 00-1.078-4.479c-.508-1.556-1.093-3.126-1.718-4.692s-1.317-3.157-1.978-4.687l-.025-.056a1.906 1.906 0 013.243-1.937 53.216 53.216 0 013.118 4.43 50.442 50.442 0 012.684 4.773c.407.834.783 1.7 1.139 2.6a19.826 19.826 0 01.9 2.872 11.74 11.74 0 01.33 3.558 6.974 6.974 0 01-.6 2.359 5.918 5.918 0 01-1.947 2.354 3.243 3.243 0 01-1.464.569h-.137a26.225 26.225 0 01-6.005-.052c-1.866-.2-3.67-.508-5.444-.869s-3.513-.788-5.241-1.256-3.4-.981-5.155-1.6a3.823 3.823 0 012.384-7.214z"
            transform="translate(-261.321 -57.233)"
          />
          <path
            id="welcomeTour_svg__Caminho_852"
            data-name="Caminho 852"
            className="welcomeTour_svg__cls-14"
            d="M320.891 73.313l-4.031-3.482 5.272-3.1s3.68 3.558 1.769 5.8z"
            transform="translate(-274.558 -54.667)"
          />
          <path
            id="welcomeTour_svg__Caminho_853"
            data-name="Caminho 853"
            className="welcomeTour_svg__cls-14"
            d="M314.6 63.6l2.328-1.464a1.464 1.464 0 011.845.224l1.911 2-5.272 3.1-1.235-1.779a1.474 1.474 0 01.423-2.081z"
            transform="translate(-273.112 -52.297)"
          />
          <path
            id="welcomeTour_svg__Caminho_854"
            data-name="Caminho 854"
            className="welcomeTour_svg__cls-10"
            d="M290.464 94.771c4.931-.742 12.968 3.848 12.968 3.848l-1.759 10.935a25.557 25.557 0 01-8.642-2.76c-1.489-.762-8.398-11.138-2.567-12.023z"
            transform="translate(-260.449 -68.413)"
          />
          <path
            id="welcomeTour_svg__Caminho_855"
            data-name="Caminho 855"
            className="welcomeTour_svg__cls-10"
            d="M270.8 94.709a79.567 79.567 0 00-19.251 4.657 7.213 7.213 0 00-4.519 7.234c.559 7.29 4.7 18.926 9.964 40.724 2.735.564 10.513-.315 16.654-1.418.666-.117 2.145-1.871 2.145-1.871s1.622 1.129 2.466.935c4.067-.925 7.234-1.983 7.9-2.867-2.074-4.951-3.823-19.485-5.455-28.183-.4-3.452-1.439-9.786-3.147-13.288-1.611-3.315-3.101-6.299-6.757-5.923z"
            transform="translate(-240.217 -68.407)"
          />
          <path
            id="welcomeTour_svg__Caminho_856"
            data-name="Caminho 856"
            className="welcomeTour_svg__cls-14"
            d="M266.906 81.35c.651 3.726 1.235 8.1-.646 10.93 1.723 2.171 5.455 3.686 9.089 4.3 2.059-2.9 1.566-5.46.422-6.873-2.2-1.312-2.064-3.589-2.11-5.16z"
            transform="translate(-249.681 -61.855)"
          />
          <path
            id="welcomeTour_svg__Caminho_857"
            data-name="Caminho 857"
            className="welcomeTour_svg__cls-9"
            d="M284.14 108.507a4.677 4.677 0 00.7-2.191c0-1.134 2.033-.544 2.033-.544a7.661 7.661 0 01-2.733 2.735z"
            transform="translate(-258.472 -73.786)"
          />
          <path
            id="welcomeTour_svg__Caminho_858"
            data-name="Caminho 858"
            className="welcomeTour_svg__cls-9"
            d="M279.469 109.979a2.069 2.069 0 00-1.927-1.357 6.609 6.609 0 00-2.9.508 13.73 13.73 0 004.827.849z"
            transform="translate(-253.801 -75.258)"
          />
          <path
            id="welcomeTour_svg__Caminho_859"
            data-name="Caminho 859"
            className="welcomeTour_svg__cls-12"
            d="M270.587 83.437c-.046-.234-.081-.473-.117-.707l5.261 2.5a9.15 9.15 0 00.427 3.223c-2.445-.721-5.129-2.769-5.571-5.016z"
            transform="translate(-251.751 -62.533)"
          />
          <path
            id="welcomeTour_svg__Caminho_860"
            data-name="Caminho 860"
            className="welcomeTour_svg__cls-4"
            d="M279.108 53.283c3.05-.508 5.18 3.05 2.542 8.088-1.81-.864-3.309-3.767-3.309-3.767z"
            transform="translate(-255.62 -48.032)"
          />
          <path
            id="welcomeTour_svg__Caminho_861"
            data-name="Caminho 861"
            className="welcomeTour_svg__cls-14"
            d="M261.028 62.491c2.094 4.535 3.091 7.3 6.365 8.749 4.926 2.181 9.821-2.242 9.12-7.325-.635-4.575-3.955-11.224-9.216-11.255a6.883 6.883 0 00-6.268 9.832z"
            transform="translate(-246.783 -47.749)"
          />
          <path
            id="welcomeTour_svg__Caminho_862"
            data-name="Caminho 862"
            className="welcomeTour_svg__cls-9"
            d="M283.283 76.67a30.122 30.122 0 00-5.653.935 3.578 3.578 0 004.118 1.439 1.861 1.861 0 001.535-2.374z"
            transform="translate(-255.271 -59.554)"
          />
          <path
            id="welcomeTour_svg__Caminho_863"
            data-name="Caminho 863"
            className="welcomeTour_svg__cls-15"
            d="M282.1 79.708a4.021 4.021 0 012.46.076 2.125 2.125 0 01-1.2.676 3.965 3.965 0 01-2.455-.076 2.084 2.084 0 011.195-.676z"
            transform="translate(-256.884 -60.971)"
          />
          <path
            id="welcomeTour_svg__Caminho_864"
            data-name="Caminho 864"
            className="welcomeTour_svg__cls-7"
            d="M283.257 76.68a.808.808 0 01-.463.763 21.636 21.636 0 01-3.716.508 1.256 1.256 0 01-1.1-.4 34.239 34.239 0 015.279-.871z"
            transform="translate(-255.443 -59.559)"
          />
          <path
            id="welcomeTour_svg__Caminho_865"
            data-name="Caminho 865"
            className="welcomeTour_svg__cls-12"
            d="M276.195 77.16s-1.159.158-.742 1.017c.035-.422.742-1.017.742-1.017z"
            transform="translate(-254.156 -59.795)"
          />
          <path
            id="welcomeTour_svg__Caminho_866"
            data-name="Caminho 866"
            className="welcomeTour_svg__cls-4"
            d="M260.814 62.11l2.069-.381s-1.428-4.006-3.147-5.084a14.071 14.071 0 003.02-4.357 6.1 6.1 0 00-1.591-6.609 7.219 7.219 0 01-3.625 4.987c-2 1.083-4.128 3.8-1.617 4.87-2.704 1.623-1.336 5.049 4.891 6.574z"
            transform="translate(-243.95 -44.318)"
          />
          <path
            id="welcomeTour_svg__Caminho_867"
            data-name="Caminho 867"
            className="welcomeTour_svg__cls-4"
            d="M268.347 52.094c4.067.1 6.878-4.067 3.355-9.094-.452 2.847-4.382 4.575-4.382 4.575z"
            transform="translate(-250.202 -43)"
          />
          <path
            id="welcomeTour_svg__Caminho_868"
            data-name="Caminho 868"
            className="welcomeTour_svg__cls-4"
            d="M276.051 51.038c2.618.63 4.682-2.338 2.72-6.858-.468 2.232-3.1 3.05-3.1 3.05z"
            transform="translate(-254.307 -43.58)"
          />
          <path
            id="welcomeTour_svg__Caminho_869"
            data-name="Caminho 869"
            className="welcomeTour_svg__cls-12"
            d="M271.733 69.966a2.73 2.73 0 00-2.033.478 5.46 5.46 0 002.033-.478z"
            transform="translate(-251.372 -56.24)"
          />
          <path
            id="welcomeTour_svg__Caminho_870"
            data-name="Caminho 870"
            className="welcomeTour_svg__cls-12"
            d="M272.242 70.92a2.247 2.247 0 00-1.672.879 4.473 4.473 0 001.672-.879z"
            transform="translate(-251.8 -56.727)"
          />
          <path
            id="welcomeTour_svg__Caminho_871"
            data-name="Caminho 871"
            className="welcomeTour_svg__cls-12"
            d="M286.47 64.4s.376-.7.808-.615a1.815 1.815 0 01-.808.615z"
            transform="translate(-259.617 -53.214)"
          />
          <path
            id="welcomeTour_svg__Caminho_872"
            data-name="Caminho 872"
            className="welcomeTour_svg__cls-12"
            d="M286.65 65.364s.4-.508.783-.193a1.062 1.062 0 01-.783.193z"
            transform="translate(-259.706 -53.849)"
          />
          <path
            id="welcomeTour_svg__Caminho_873"
            data-name="Caminho 873"
            className="welcomeTour_svg__cls-14"
            d="M260.42 76.788a4.682 4.682 0 003.015 1.972c1.637.3 2.323-1.2 1.754-2.669-.508-1.322-1.983-3.05-3.558-2.7a2.159 2.159 0 00-1.211 3.397z"
            transform="translate(-246.606 -57.918)"
          />
          <path
            id="welcomeTour_svg__Caminho_874"
            data-name="Caminho 874"
            className="welcomeTour_svg__cls-9"
            d="M275.118 69.144c.147.376.468.6.717.508s.325-.508.178-.864-.468-.6-.717-.508-.326.478-.178.864z"
            transform="translate(-253.999 -55.418)"
          />
          <path
            id="welcomeTour_svg__Caminho_875"
            data-name="Caminho 875"
            className="welcomeTour_svg__cls-9"
            d="M284.39 65.444c.147.376.468.6.717.508s.325-.508.178-.864-.468-.6-.712-.508-.33.483-.183.864z"
            transform="translate(-258.559 -53.599)"
          />
          <path
            id="welcomeTour_svg__Caminho_876"
            data-name="Caminho 876"
            className="welcomeTour_svg__cls-15"
            d="M281.4 67.55a14.464 14.464 0 003.157 2.4 2.353 2.353 0 01-1.627 1.123z"
            transform="translate(-257.125 -55.07)"
          />
          <path
            id="welcomeTour_svg__Caminho_877"
            data-name="Caminho 877"
            className="welcomeTour_svg__cls-9"
            d="M271.185 64.441a.2.2 0 01-.122 0 .234.234 0 01-.163-.295 2.384 2.384 0 011.449-1.637.234.234 0 01.295.153.239.239 0 01-.153.3 1.927 1.927 0 00-1.134 1.317.249.249 0 01-.172.162z"
            transform="translate(-251.957 -52.586)"
          />
          <path
            id="welcomeTour_svg__Caminho_878"
            data-name="Caminho 878"
            className="welcomeTour_svg__cls-9"
            d="M283.641 59.951a.259.259 0 01-.229 0 1.861 1.861 0 00-1.718-.086.239.239 0 01-.32-.1.244.244 0 01.1-.325 2.349 2.349 0 012.171.086.234.234 0 01.1.32.31.31 0 01-.104.105z"
            transform="translate(-257.098 -50.974)"
          />
          <path
            id="welcomeTour_svg__Caminho_879"
            data-name="Caminho 879"
            className="welcomeTour_svg__cls-14"
            d="M247.343 114.448c-.549 1.591-1.159 3.2-1.728 4.8l-1.759 4.794-1.754 4.784c-.564 1.6-1.144 3.182-1.688 4.763l-.025-2.033a33.992 33.992 0 001.988 4.977c.813 1.718 1.688 3.457 2.6 5.185s1.845 3.462 2.786 5.2l2.837 5.216a1.9 1.9 0 01-3.1 2.166c-1.347-1.525-2.6-3.1-3.843-4.692s-2.435-3.228-3.6-4.89-2.288-3.375-3.34-5.17a34.57 34.57 0 01-2.893-5.877 3 3 0 01-.086-1.764l.066-.254c.432-1.713.879-3.406 1.378-5.084s1.017-3.34 1.525-4.992 1.088-3.3 1.667-4.931 1.164-3.259 1.82-4.885a3.819 3.819 0 117.158 2.664z"
            transform="translate(-233.647 -75.431)"
          />
          <path
            id="welcomeTour_svg__Caminho_880"
            data-name="Caminho 880"
            className="welcomeTour_svg__cls-10"
            d="M247.184 103.91c-5.465 1.952-8.454 12.627-8.454 12.627l8.708 7.757a12.224 12.224 0 004.321-8.022c.559-4.203.976-14.365-4.575-12.362z"
            transform="translate(-236.146 -72.704)"
          />
          <path
            id="welcomeTour_svg__Caminho_881"
            data-name="Caminho 881"
            className="welcomeTour_svg__cls-14"
            d="M261.092 188.86l4.484 2.425-4.3 4.352s-3.8-2.689-2.694-4.936z"
            transform="translate(-245.809 -114.455)"
          />
          <path
            id="welcomeTour_svg__Caminho_882"
            data-name="Caminho 882"
            className="welcomeTour_svg__cls-14"
            d="M269.931 198.693l-1.764 1.271a1.769 1.769 0 01-2.283-.183l-1.8-1.8 4.3-4.352 1.937 2.567a1.769 1.769 0 01-.381 2.5z"
            transform="translate(-248.609 -116.792)"
          />
          <path
            id="welcomeTour_svg__Caminho_883"
            data-name="Caminho 883"
            className="welcomeTour_svg__cls-7"
            d="M266.271 98.53c.234 1.134 1.271 4.921 6.385 5.134-1.764.574-2.181 3.935-2.181 3.935s-5.261-3.314-5.775-7.463c.153-1.093 1.571-1.606 1.571-1.606z"
            transform="translate(-248.914 -70.301)"
          />
          <path
            id="welcomeTour_svg__Caminho_884"
            data-name="Caminho 884"
            className="welcomeTour_svg__cls-7"
            d="M282.16 94.63c.229 1.108 1.952 2.964 1.708 6.283 1.774-.544 4.016.956 4.016.956a13.8 13.8 0 00-3.558-6.776 5.119 5.119 0 00-2.166-.463z"
            transform="translate(-257.498 -68.384)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgWelcomeTour;

